import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x",
  "use": "x-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"x\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.471 3.529c.26.26.26.682 0 .942l-8 8a.667.667 0 11-.942-.942l8-8c.26-.26.682-.26.942 0z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.529 3.529c.26-.26.682-.26.942 0l8 8a.667.667 0 11-.942.942l-8-8a.667.667 0 010-.942z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol